import { render } from "./AlunosModal.vue?vue&type=template&id=73853b4c"
import script from "./AlunosModal.vue?vue&type=script&lang=js"
export * from "./AlunosModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__